export default __webpack_public_path__ + "static/media/TempSensors.db439cf2.jpg";